/**
 * @module getLayerByName
 */

/**
 * get a layer by name
 * @param {object} map 
 * @param {string} name 
 * @returns {object} layer
 */
function getLayerByName(map, name) {
  return map.getLayers().getArray().find(layer => layer.get('name') === name);
}

export { getLayerByName };